module.exports = __webpack_public_path__ + "img/icon-x.297c8310.svg";